export default __webpack_public_path__ + "static/media/22.c96eb30b.jpg";